import { createAction, handleActions } from 'redux-actions';

const setActiveTab = createAction("SCREENS/SUBCONTRACTOR_VIEW/SET_ACTIVE_TAB");
const resetActiveTab = createAction("SCREENS/SUBCONTRACTOR_VIEW/RESET_ACTIVE_TAB");

const defaultState = 'FILES';

const reducer = handleActions(
  {
    [setActiveTab]: (state, action) => action.payload,
    [resetActiveTab]: () => defaultState
  },
  defaultState
);

export { setActiveTab, resetActiveTab, reducer };
